import { CountryCode, parsePhoneNumberWithError, PhoneNumber } from 'libphonenumber-js'
import { correctCountryCode } from './country-map'

export function formatPhoneNumber(countryCode: string, phoneNumber: string) {
	if (!countryCode || !phoneNumber) {
		return phoneNumber
	}

	countryCode = correctCountryCode(countryCode)

	let parsedPhoneNumber: PhoneNumber | null = null

	try {
		parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber, countryCode as CountryCode)
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	} catch (e) {
		return phoneNumber
	}

	if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
		if (countryCode === 'US') {
			return parsedPhoneNumber.formatNational()
		} else {
			return parsedPhoneNumber.formatInternational()
		}
	}

	return phoneNumber
}

export function stripPhoneNumber(phoneNumber: string) {
	return phoneNumber.replace(/[^0-9]/g, '')
}
